
import { createAction } from 'redux-actions'
import request from 'superagent'

export const REQUEST_PLANS = 'REQUEST_PLANS'
export const REQUEST_PLANS_ERROR = 'REQUEST_PLANS_ERROR'
export const RECEIVE_PLANS = 'RECEIVE_PLANS'

const requestPlans = createAction(REQUEST_PLANS)
const requestPlansError = createAction(REQUEST_PLANS_ERROR)
const receivePlans = createAction(RECEIVE_PLANS)

export function fetchPlans (version = 3) {
  return (dispatch) => {
    dispatch(requestPlans())
    request
    .get(`/api/plans/${version}`)
    .end(function (err, res) {
      if (err || !res.ok) {
        const error = new Error('Unable to fetch plans')
        dispatch(requestPlansError(error))
      } else {
        dispatch(receivePlans(res.body))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./actions/plans.js